<template>
  <div style="padding-right:25px;">
    <b-card>
      <b-form-group>
        <center>
          <h3 id="doc_caution_title">Caution</h3>
        </center>
        <hr>
        <p class="doc_caution_content">This report is confidential with the user`s asset information.</p>
        <p class="doc_caution_content">Please refer to the following notes for the report management.</p>
        <p class="doc_caution_content">1. prohibits any outflows.</p>
        <p class="doc_caution_content">2. not reprinted or reprinted without permission.</p>
        <p class="doc_caution_content">3. forbidden to be viewed except by security officers by security officers</p>
        <p class="doc_caution_content">and related personnel</p>
      </b-form-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "caution",
  data: () => {
    return {};
  },
  created: function() {
    console.log("[F1-UWSS]Caution.vue", "created");
  },
  destroyed: function() {
    console.log("[F1-UWSS]Caution.vue", "destroyed");
  },
  mounted: function() {
    console.log("[F1-UWSS]Caution.vue", "mounted");
  }
};
</script>
